/** Halaman eksport daftar daerah (Perancangan Fasa 3 P3-6a): lapisan guna tanah komited, satu daerah satu fail. */
export default {
  registerExport: {
    navLabel: 'Eksport daerah',
    title: 'Eksport daftar daerah',
    subtitle: 'Lapisan guna tanah komited (lapisan K) untuk PLANMalaysia, satu daerah satu fail.',
    notPermitted: 'Hanya pentadbir atau pelulus boleh mengeksport daftar.',
    unavailable: 'Eksport daerah dibuka bersama prosedur KM. Ia belum tersedia.',
    area: 'Daerah',
    areaPlaceholder: 'Pilih daerah',
    sequence: 'Nombor siri',
    sequenceHint:
      'Cadangan: {{proposed}}. Sebarang nombor 01 hingga 99; menggunakan semula nombor terdahulu tidak mengubah cadangan.',
    sequenceInvalid: 'Masukkan nombor 1 hingga 99.',
    fileName: 'Nama fail: {{name}}',
    periodFrom: 'Diluluskan dari',
    periodTo: 'Diluluskan hingga',
    periodHint: 'Biarkan kedua-dua tarikh kosong untuk mengeksport setiap kebenaran yang berkuat kuasa.',
    submit: 'Eksport',
    submitting: 'Sedang beratur…',
    queued: 'Eksport telah dibariskan. Biasanya ia mengambil beberapa minit.',
    recent: 'Eksport terkini',
    none: 'Belum ada eksport.',
    download: 'Muat turun',
    downloading: 'Sedang disediakan…',
    showReport: 'Tunjuk laporan',
    hideReport: 'Sembunyi laporan',
    reportTitle: 'Laporan pengesahan',
    passed: 'Lulus',
    notPassed: 'Tidak lulus',
    counts: '{{rows}} baris daripada {{cases}} penyerahan',
    rate: '{{name}}: kadar {{rate}}',
    limit: 'had {{limit}}',
    overlap: 'Pertindihan',
    gap: 'Ruang kosong',
    failuresTitle: 'Mesti dibetulkan sebelum dihantar',
    warningsTitle: 'Untuk disemak',
    cases: 'Penyerahan: {{refs}}',
    fields: 'Medan: {{fields}}',
    columns: {
      file: 'Fail',
      area: 'Daerah',
      status: 'Keadaan',
      rows: 'Baris',
      size: 'Saiz',
      requested: 'Diminta',
      actions: 'Tindakan',
    },
    status: { queued: 'Dalam barisan', running: 'Sedang dibina', done: 'Sedia', failed: 'Gagal' },
    errorCodes: {
      REGISTER_EXPORT_FAILED: 'Eksport gagal. Cuba lagi; jika gagal lagi, hubungi sokongan.',
      REGISTER_EXPORT_EMPTY: 'Tiada kebenaran berkuat kuasa di daerah ini yang dapat dieksport.',
      REGISTER_EXPORT_TOO_LARGE: 'Fail itu terlalu besar untuk dihantar.',
      REGISTER_EXPORT_STALE: 'Eksport terhenti sebelum selesai. Mulakannya semula.',
    },
    failures: {
      no_rows: 'Tiada baris yang dieksport.',
      overlap_rate: 'Plot bertindih melebihi had yang dibenarkan.',
      gap_rate: 'Plot meninggalkan kawasan tapak yang tidak diliputi melebihi had.',
      empty_attributes: 'Medan wajib kosong pada beberapa baris.',
      truncated: 'Beberapa nilai lebih panjang daripada had medannya.',
      gtn_paths: 'Beberapa baris membawa laluan kelas guna tanah yang tiada dalam senarai rasmi.',
      lot_duplicates: 'Satu nombor lot muncul dalam lebih daripada satu penyerahan bagi satu mukim.',
      refused_rows: 'Beberapa baris dilukis dalam datum Kertau dan tidak dimasukkan.',
    },
    warnings: {
      without_upi: 'Beberapa baris tiada UPI.',
      missing_area: 'Beberapa kebenaran berkuat kuasa tidak menamakan daerah dan tidak dieksport.',
      legacy_without_decision_number: 'Kelulusan sebelum keputusan bernombor tiada nombor sijil.',
      imported_without_rows: 'Penyerahan diluluskan yang diimport dari sistem lain tiada baris di sini.',
      local_without_rows: 'Beberapa penyerahan diluluskan di daerah ini tiada baris yang dieksport.',
    },
    tiers: {
      title: 'Kelas guna tanah, peringkat 2 dan 3',
      intro: 'Import kelas rasmi peringkat 2 dan 3 sebagai fail JSON. Eksport menulis teks dan kodnya.',
      count: '{{count}} kelas diimport',
      none: 'Belum ada kelas peringkat 2 atau 3 diimport.',
      import: 'Import fail JSON',
      download: 'Muat turun fail JSON',
      clear: 'Buang semua',
      save: 'Simpan kelas',
      saving: 'Sedang disimpan…',
      saved: 'Kelas disimpan.',
      cancel: 'Batal',
      pending: '{{count}} kelas sedia untuk disimpan',
      invalid: {
        json: 'Fail itu bukan JSON yang sah.',
        shape:
          'Entri {{position}} bukan kelas yang sah (kod, induk, peringkat 2 atau 3, teks rasmi, kod hingga 7 huruf besar).',
        too_many: 'Satu fail boleh memuatkan paling banyak 600 kelas.',
        duplicate: 'Entri {{position}} mengulang kod kelas.',
      },
    },
  },
  errors: {
    invalid_register_export: 'Butiran eksport itu tidak sah.',
    register_export_unavailable: 'Eksport daerah dibuka bersama prosedur KM. Ia belum tersedia.',
    register_export_not_found: 'Eksport itu tidak dijumpai.',
    register_export_not_ready: 'Eksport itu belum sedia.',
    too_many_register_exports: 'Satu eksport sedang dibina. Tunggu sehingga ia selesai.',
  },
} as const
